/*
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2023-06-07 12:14:03
 * @FilePath: \dbarsdgs\src\util\util.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const utils = {
    ImageUrl: 'http://opendbar.casearth.cn/images',
    baseUrl: 'http://opendbar.casearth.cn/',
    adminApi: 'http://opendbar.casearth.cn/admin-api',
    sdgApi: 'http://opendbar.casearth.cn/sdg-api',
    // sdgApi: 'http://60.245.209.50/sdg-api',
    ssoApi: 'http://opendbar.casearth.cn/sso-api'

}

export default utils 